/**
 * 支持的语言环境
 */
import english_flag from '../../assets/img/english_flag.png';
import china_flag from '../../assets/img/china_flag.png';
import japan_flag from '../../assets/img/japan_flag.png';
import vietnam_flag from '../../assets/img/vietnam_flag.png';
import russia_flag from '../../assets/img/russia_flag.png';
import turkey_flag from '../../assets/img/turkey_flag.png';
import spanish_flag from '../../assets/img/spanish_flag.png';
import brazil_flag from '../../assets/img/brazil_flag.png';

import lang from 'element-plus/es/locale/lang/en';
import langZhCn from 'element-plus/es/locale/lang/zh-cn';
import langZhTW from 'element-plus/es/locale/lang/zh-tw';
import langJp from 'element-plus/es/locale/lang/ja';
import langEs from 'element-plus/es/locale/lang/es';
import langPt from 'element-plus/es/locale/lang/pt';
import langRu from 'element-plus/es/locale/lang/ru';
import langTr from 'element-plus/es/locale/lang/tr';
import langVi from 'element-plus/es/locale/lang/vi';

const domain_env = import.meta.env.VITE_DOMAIN_ENV;

// 全局品牌色设置
export const BRAND_COLOR_CONFIG = {
  dark: '#01E0E0',
  light: '#00C0CC',
  dark_rgb: '1, 224, 224',
  light_rgb: '0, 192, 204',
}

export const LANG_ELEMENT_MAP = {
  'vi-VN': langVi,
  'en-US': lang,
  'es-ES': langEs,
  'ja-JP': langJp,
  'pt-BR': langPt,
  'ru-RU': langRu,
  'tr-TR': langTr,
  'zh-CN': langZhCn,
  'zh-TW': langZhTW,
  'en-AU': lang,
};

// 语言配置
export const LOCALES = ['en', 'jp', 'cn', 'vn', 'ru', 'tr', 'es', 'br'];

// 项目的默认语言常量，重构后为大写
export const DEFAULT_LOCALE = 'en-US';

// 老版本语言的映射关系
export const OLD_LOCALES_OBJ = {
  'en-US': 'en',
  'zh-CN': 'cn',
  'ja-JP': 'jp',
  'vi-VN': 'vn',
  'ru-RU': 'ru',
  'tr-TR': 'tr',
  'es-ES': 'es',
  'pt-BR': 'br',
  'ko-KR': 'kr',
};

// 老版本的反向映射关系 - 跟合约保持一致，为了导航条能引用的到
export const OLD_LOCALES_OBJ_REVERSE = {
  en: 'en-US',
  br: 'pt-BR',
  kr: 'ko-KR',
  ru: 'ru-RU',
  es: 'es-ES',
  tr: 'tr-TR',
  cn: 'zh-CN',
  jp: 'ja-JP',
  vn: 'vi-VN',
};

export const unPriceList = ['es', 'br']; // 后端不支持的订阅语言, 语言配置
export const normalizedUnPriceList = ['es_ES', 'pt_BR'];

export const langObj = {
  cn: {
    desc1: 'zh_CN',
    desc2: 'zh-cn',
  },
  en: {
    desc1: 'en_US',
    desc2: 'en-us',
  },
  jp: {
    desc1: 'ja_JP',
    desc2: 'ja-jp',
  },
  vn: {
    desc1: 'vi-VN',
    desc2: 'vi_VN',
  },
  // 暂时去掉韩国
  // kr: {
  //   desc1: 'ko-KR',
  //   desc2: 'ko_KR',
  // },
  ru: {
    desc1: 'ru-RU',
    desc2: 'ru_RU',
  },
  tr: {
    desc1: 'tr-TR',
    desc2: 'tr_TR',
  },
  es: {
    desc1: 'es-ES',
    desc2: 'es_ES',
  },
  br: {
    desc1: 'pt-BR',
    desc2: 'pt_BR',
  },
};

export const countryCode = [
  '376',
  '971',
  '93',
  '1268',
  '1264',
  '355',
  '374',
  '244',
  '672',
  '54',
  '1684',
  '43',
  '297',
  '35818',
  '994',
  '387',
  '1246',
  '880',
  '32',
  '226',
  '359',
  '973',
  '257',
  '229',
  '1441',
  '673',
  '591',
  '5997',
  '55',
  '1242',
  '975',
  '267',
  '501',
  // '1_1',
  '236',
  '242',
  '41',
  '225',
  '682',
  '56',
  '237',
  '86',
  '57',
  '506',
  '238',
  '5999',
  '61',
  '357',
  '420',
  '49',
  '253',
  '45',
  '1767',
  '1809',
  '213',
  '593',
  '372',
  '20',
  '291',
  '34',
  '251',
  '358',
  '679',
  '691',
  '298',
  '33',
  '241',
  '1473',
  '995',
  '594',
  '44',
  '233',
  '350',
  '299',
  '220',
  '224',
  '590',
  '240',
  '30',
  '500',
  '502',
  '1671',
  '245',
  '592',
  '852',
  '504',
  '385',
  '509',
  '36',
  '62',
  '353',
  '972',
  '91',
  '246',
  '354',
  '39',
  '1876',
  '962',
  '81',
  '254',
  '996',
  '855',
  '686',
  '269',
  '1869',
  '82',
  '965',
  '1345',
  // '7',
  '856',
  '961',
  '1758',
  '423',
  '94',
  '231',
  '266',
  '370',
  '352',
  '371',
  '218',
  '212',
  '377',
  '373',
  '382',
  '261',
  '692',
  '389',
  '223',
  '95',
  '976',
  '853',
  '1670',
  '596',
  '222',
  '1664',
  '356',
  '230',
  '960',
  '265',
  '52',
  '60',
  '258',
  '264',
  '687',
  '227',
  '234',
  '505',
  '31',
  '47',
  '977',
  '674',
  '683',
  '64',
  '968',
  '507',
  '51',
  '689',
  '675',
  '63',
  '92',
  '48',
  '508',
  '1787',
  '970',
  '351',
  '680',
  '595',
  '974',
  '40',
  '381',
  '7',
  '250',
  '966',
  '677',
  '248',
  '46',
  '65',
  '290',
  '386',
  '421',
  '232',
  '378',
  '221',
  '252',
  '597',
  '211',
  '239',
  '503',
  '1721',
  '268',
  '1649',
  '235',
  '228',
  '66',
  '992',
  '690',
  '993',
  '216',
  '676',
  '90',
  '1868',
  '688',
  '886',
  '255',
  '380',
  '256',
  '1_2',
  '598',
  '998',
  '379',
  '1784',
  '58',
  '1284',
  '1340',
  '84',
  '678',
  '681',
  '685',
  '383',
  '967',
  '262',
  '27',
  '260',
];

const CodeDataMap = [
  ['376', { flag: '🇦🇩', name: '安道尔', englishName: 'Andorra' }],
  ['971', { flag: '🇦🇪', name: '阿联酋', englishName: 'United Arab Emirates' }],
  ['93', { flag: '🇦🇫', name: '阿富汗', englishName: 'Afghanistan' }],
  ['1268', { flag: '🇦🇬', name: '安提瓜和巴布达', englishName: 'Antigua and Barbuda' }],
  ['1264', { flag: '🇦🇮', name: '安圭拉', englishName: 'Anguilla' }],
  ['355', { flag: '🇦🇱', name: '阿尔巴尼亚', englishName: 'Albania (Shqipëri)' }],
  ['374', { flag: '🇦🇲', name: '亚美尼亚', englishName: 'Armenia (Հայաստան)' }],
  ['244', { flag: '🇦🇴', name: '安哥拉', englishName: 'Angola' }],
  ['672', { flag: '🇦🇶', name: '南极洲', englishName: 'Antarctica' }],
  ['54', { flag: '🇦🇷', name: '阿根廷', englishName: 'Argentina' }],
  ['1684', { flag: '🇦🇸', name: '美属萨摩亚', englishName: 'American Samoa' }],
  ['43', { flag: '🇦🇹', name: '奥地利', englishName: 'Austria (Österreich)' }],
  ['61', { flag: '🇦🇺', name: '澳大利亚', englishName: 'Australia' }],
  ['297', { flag: '🇦🇼', name: '阿鲁巴', englishName: 'Aruba' }],
  ['35818', { flag: '🇦🇽', name: '奥兰群岛', englishName: 'Åland Islands' }],
  ['994', { flag: '🇦🇿', name: '阿塞拜疆', englishName: 'Azerbaijan (Azərbaycan)' }],
  ['387', { flag: '🇧🇦', name: '波黑', englishName: 'Bosnia and Herzegovina (Босна и Херцеговина)' }],
  ['1246', { flag: '🇧🇧', name: '巴巴多斯', englishName: 'Barbados' }],
  ['880', { flag: '🇧🇩', name: '孟加拉', englishName: 'Bangladesh (বাংলাদেশ)' }],
  ['32', { flag: '🇧🇪', name: '比利时', englishName: 'Belgium (België)' }],
  ['226', { flag: '🇧🇫', name: '布基纳法索', englishName: 'Burkina Faso' }],
  ['359', { flag: '🇧🇬', name: '保加利亚', englishName: 'Bulgaria (България)' }],
  ['973', { flag: '🇧🇭', name: '巴林', englishName: 'Bahrain' }],
  ['257', { flag: '🇧🇮', name: '布隆迪', englishName: 'Burundi (Uburundi)' }],
  ['229', { flag: '🇧🇯', name: '贝宁', englishName: 'Benin (Bénin)' }],
  ['1441', { flag: '🇧🇲', name: '百慕大', englishName: 'Bermuda' }],
  ['673', { flag: '🇧🇳', name: '文莱', englishName: 'Brunei' }],
  ['591', { flag: '🇧🇴', name: '玻利维亚', englishName: 'Bolivia' }],
  ['5997', { flag: '🇧🇶', name: '荷兰加勒比区', englishName: 'Caribbean Netherlands' }],
  ['55', { flag: '🇧🇷', name: '巴西', englishName: 'Brazil (Brasil)' }],
  ['1242', { flag: '🇧🇸', name: '巴哈马', englishName: 'Bahamas' }],
  ['975', { flag: '🇧🇹', name: '不丹', englishName: 'Bhutan (འབྲུག)' }],
  ['267', { flag: '🇧🇼', name: '博茨瓦纳', englishName: 'Botswana' }],
  ['501', { flag: '🇧🇿', name: '伯利兹', englishName: 'Belize' }],
  ['1_2', { flag: '🇨🇦', name: '加拿大', englishName: 'Canada' }],
  ['61', { flag: '🇨🇨', name: '科科斯群岛', englishName: 'Cocos (Keeling) Islands' }],
  ['236', { flag: '🇨🇫', name: '中非', englishName: 'Central African Republic (République centrafricaine)' }],
  ['242', { flag: '🇨🇩', name: '刚果（布）', englishName: 'Congo (Republic) (Congo-Brazzaville)' }],
  ['41', { flag: '🇨🇭', name: '瑞士', englishName: 'Switzerland (Schweiz)' }],
  ['225', { flag: '🇨🇮', name: '科特迪瓦', englishName: 'Côte d’Ivoire' }],
  ['682', { flag: '🇨🇰', name: '库克群岛', englishName: 'Cook Islands' }],
  ['56', { flag: '🇨🇱', name: '智利', englishName: 'Chile' }],
  ['237', { flag: '🇨🇲', name: '喀麦隆', englishName: 'Cameroon (Cameroun)' }],
  ['86', { flag: '🇨🇳', name: '中国', englishName: 'China (中国)' }],
  ['57', { flag: '🇨🇴', name: '哥伦比亚', englishName: 'Colombia' }],
  ['506', { flag: '🇨🇷', name: '哥斯达黎加', englishName: 'Costa Rica' }],
  ['238', { flag: '🇨🇻', name: '佛得角', englishName: 'Cape Verde (Kabu Verdi)' }],
  ['5999', { flag: '🇨🇼', name: '库拉索', englishName: 'Curaçao' }],
  ['61', { flag: '🇨🇽', name: '圣诞岛', englishName: 'Christmas Island' }],
  ['357', { flag: '🇨🇾', name: '塞浦路斯', englishName: 'Cyprus (Κύπρος)' }],
  ['420', { flag: '🇨🇿', name: '捷克', englishName: 'Czech Republic (Česká republika)' }],
  ['49', { flag: '🇩🇪', name: '德国', englishName: 'Germany (Deutschland)' }],
  ['253', { flag: '🇩🇯', name: '吉布提', englishName: 'Djibouti' }],
  ['45', { flag: '🇩🇰', name: '丹麦', englishName: 'Denmark (Danmark)' }],
  ['1767', { flag: '🇩🇲', name: '多米尼克', englishName: 'Dominica' }],
  ['1809', { flag: '🇩🇲', name: '多米尼加', englishName: 'Dominican Republic (República Dominicana)' }],
  ['213', { flag: '🇩🇿', name: '阿尔及利亚', englishName: 'Algeria' }],
  ['593', { flag: '🇪🇨', name: '厄瓜多尔', englishName: 'Ecuador' }],
  ['372', { flag: '🇪🇪', name: '爱沙尼亚', englishName: 'Estonia (Eesti)' }],
  ['20', { flag: '🇪🇬', name: '埃及', englishName: 'Egypt' }],
  ['291', { flag: '🇪🇷', name: '厄立特里亚', englishName: 'Eritrea' }],
  ['34', { flag: '🇪🇸', name: '西班牙', englishName: 'Spain (España)' }],
  ['251', { flag: '🇪🇹', name: '埃塞俄比亚', englishName: 'Ethiopia' }],
  ['358', { flag: '🇫🇮', name: '芬兰', englishName: 'Finland (Suomi)' }],
  ['679', { flag: '🇫🇯', name: '斐济群岛', englishName: 'Fiji' }],
  ['500', { flag: '🇫🇰', name: '马尔维纳斯群岛（福克兰）', englishName: 'Falkland Islands (Islas Malvinas)' }],
  ['691', { flag: '🇫🇲', name: '密克罗尼西亚联邦', englishName: 'Micronesia' }],
  ['298', { flag: '🇫🇴', name: '法罗群岛', englishName: 'Faroe Islands (Føroyar)' }],
  ['33', { flag: '🇫🇷', name: '法国', englishName: 'France' }],
  ['241', { flag: '🇬🇦', name: '加蓬', englishName: 'Gabon' }],
  ['44', { flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', name: '英国', englishName: 'United Kingdom' }],
  ['1473', { flag: '🇬🇩', name: '格林纳达', englishName: 'Grenada' }],
  ['995', { flag: '🇬🇪', name: '格鲁吉亚', englishName: 'Georgia (საქართველო)' }],
  ['594', { flag: '🇬🇫', name: '法属圭亚那', englishName: 'French Guiana (Guyane française)' }],
  ['44', { flag: '🇬🇬', name: '根西岛', englishName: 'Guernsey' }],
  ['233', { flag: '🇬🇭', name: '加纳', englishName: 'Ghana (Gaana)' }],
  ['350', { flag: '🇬🇮', name: '直布罗陀', englishName: 'Gibraltar' }],
  ['299', { flag: '🇬🇱', name: '格陵兰', englishName: 'Greenland (Kalaallit Nunaat)' }],
  ['220', { flag: '🇬🇲', name: '冈比亚', englishName: 'Gambia' }],
  ['224', { flag: '🇬🇳', name: '几内亚', englishName: 'Guinea (Guinée)' }],
  ['590', { flag: '🇬🇵', name: '瓜德罗普', englishName: 'Guadeloupe' }],
  ['240', { flag: '🇬🇶', name: '赤道几内亚', englishName: 'Equatorial Guinea (Guinea Ecuatorial)' }],
  ['30', { flag: '🇬🇷', name: '希腊', englishName: 'Greece (Ελλάδα)' }],
  [
    '500',
    { flag: '🇬🇸', name: '南乔治亚岛和南桑威奇群岛', englishName: 'South Georgia and the South Sandwich Islands' },
  ],
  ['502', { flag: '🇬🇹', name: '危地马拉', englishName: 'Guatemala' }],
  ['1671', { flag: '🇬🇺', name: '关岛', englishName: 'Guam' }],
  ['245', { flag: '🇬🇼', name: '几内亚比绍', englishName: 'Guinea-Bissau (Guiné Bissau)' }],
  ['592', { flag: '🇬🇾', name: '圭亚那', englishName: 'Guyana' }],
  ['852', { flag: '🇭🇰', name: '香港', englishName: 'Hong Kong (香港)' }],
  ['504', { flag: '🇭🇳', name: '洪都拉斯', englishName: 'Honduras' }],
  ['385', { flag: '🇭🇷', name: '克罗地亚', englishName: 'Croatia (Hrvatska)' }],
  ['509', { flag: '🇭🇹', name: '海地', englishName: 'Haiti' }],
  ['36', { flag: '🇭🇺', name: '匈牙利', englishName: 'Hungary (Magyarország)' }],
  ['62', { flag: '🇮🇩', name: '印尼', englishName: 'Indonesia' }],
  ['353', { flag: '🇮🇪', name: '爱尔兰', englishName: 'Ireland' }],
  ['972', { flag: '🇮🇱', name: '以色列', englishName: 'Israel' }],
  ['91', { flag: '🇮🇳', name: '印度', englishName: 'India (भारत)' }],
  ['246', { flag: '🇮🇴', name: '英属印度洋领地', englishName: 'British Indian Ocean Territory' }],
  ['354', { flag: '🇮🇸', name: '冰岛', englishName: 'Iceland (Ísland)' }],
  ['39', { flag: '🇮🇹', name: '意大利', englishName: 'Italy (Italia)' }],
  ['44', { flag: '🇯🇪', name: '泽西岛', englishName: 'Jersey' }],
  ['1876', { flag: '🇯🇲', name: '牙买加', englishName: 'Jamaica' }],
  ['962', { flag: '🇯🇴', name: '约旦', englishName: 'Jordan' }],
  ['81', { flag: '🇯🇵', name: '日本', englishName: 'Japan (日本)' }],
  ['254', { flag: '🇰🇪', name: '肯尼亚', englishName: 'Kenya' }],
  ['996', { flag: '🇰🇬', name: '吉尔吉斯斯坦', englishName: 'Kyrgyzstan (Кыргызстан)' }],
  ['855', { flag: '🇰🇭', name: '柬埔寨', englishName: 'Cambodia (កម្ពុជា)' }],
  ['686', { flag: '🇰🇮', name: '基里巴斯', englishName: 'Kiribati' }],
  ['269', { flag: '🇰🇲', name: '科摩罗', englishName: 'Comoros' }],
  ['1869', { flag: '🇰🇳', name: '圣基茨和尼维斯', englishName: 'Saint Kitts and Nevis' }],
  ['82', { flag: '🇰🇷', name: '韩国', englishName: 'South Korea (대한민국)' }],
  ['965', { flag: '🇰🇼', name: '科威特', englishName: 'Kuwait' }],
  ['1345', { flag: '🇰🇾', name: '开曼群岛', englishName: 'Cayman Islands' }],
  ['7', { flag: '🇰🇿', name: '哈萨克斯坦', englishName: 'Kazakhstan (Казахстан)' }],
  ['856', { flag: '🇱🇦', name: '老挝', englishName: 'Laos (ລາວ)' }],
  ['961', { flag: '🇱🇧', name: '黎巴嫩', englishName: 'Lebanon' }],
  ['1758', { flag: '🇱🇨', name: '圣卢西亚', englishName: 'Saint Lucia' }],
  ['423', { flag: '🇱🇮', name: '列支敦士登', englishName: 'Liechtenstein' }],
  ['94', { flag: '🇱🇰', name: '斯里兰卡', englishName: 'Sri Lanka (ශ්' }],
  ['231', { flag: '🇱🇷', name: '利比里亚', englishName: 'Liberia' }],
  ['266', { flag: '🇱🇸', name: '莱索托', englishName: 'Lesotho' }],
  ['370', { flag: '🇱🇹', name: '立陶宛', englishName: 'Lithuania (Lietuva)' }],
  ['352', { flag: '🇱🇺', name: '卢森堡', englishName: 'Luxembourg' }],
  ['371', { flag: '🇱🇻', name: '拉脱维亚', englishName: 'Latvia (Latvija)' }],
  ['218', { flag: '🇱🇾', name: '利比亚', englishName: 'Libya' }],
  ['212', { flag: '🇲🇦', name: '摩洛哥', englishName: 'Morocco' }],
  ['377', { flag: '🇲🇨', name: '摩纳哥', englishName: 'Monaco' }],
  ['373', { flag: '🇲🇩', name: '摩尔多瓦', englishName: 'Moldova (Republica Moldova)' }],
  ['382', { flag: '🇲🇪', name: '黑山', englishName: 'Montenegro (Crna Gora)' }],
  ['590', { flag: '🇲🇫', name: '法属圣马丁', englishName: 'Saint Martin (Saint-Martin (partie française))' }],
  ['261', { flag: '🇲🇬', name: '马达加斯加', englishName: 'Madagascar (Madagasikara)' }],
  ['692', { flag: '🇲🇭', name: '马绍尔群岛', englishName: 'Marshall Islands' }],
  ['389', { flag: '🇲🇰', name: '马其顿', englishName: 'Macedonia (FYROM) (Македонија)' }],
  ['223', { flag: '🇲🇱', name: '马里', englishName: 'Mali' }],
  ['95', { flag: '🇲🇲', name: '缅甸', englishName: 'Myanmar (Burma) (မြန်မာ)' }],
  ['976', { flag: '🇲🇳', name: '蒙古国', englishName: 'Mongolia (Монгол)' }],
  ['853', { flag: '🇲🇴', name: '澳门', englishName: 'Macau (澳門)' }],
  ['1670', { flag: '🇲🇵', name: '北马里亚纳群岛', englishName: 'Northern Mariana Islands' }],
  ['596', { flag: '🇲🇶', name: '马提尼克', englishName: 'Martinique' }],
  ['222', { flag: '🇲🇷', name: '毛里塔尼亚', englishName: 'Mauritania' }],
  ['1664', { flag: '🇲🇸', name: '蒙塞拉特岛', englishName: 'Montserrat' }],
  ['356', { flag: '🇲🇹', name: '马耳他', englishName: 'Malta' }],
  ['230', { flag: '🇲🇺', name: '毛里求斯', englishName: 'Mauritius (Moris)' }],
  ['960', { flag: '🇲🇻', name: '马尔代夫', englishName: 'Maldives' }],
  ['265', { flag: '🇲🇼', name: '马拉维', englishName: 'Malawi' }],
  ['52', { flag: '🇲🇽', name: '墨西哥', englishName: 'Mexico (México)' }],
  ['60', { flag: '🇲🇾', name: '马来西亚', englishName: 'Malaysia' }],
  ['258', { flag: '🇲🇿', name: '莫桑比克', englishName: 'Mozambique (Moçambique)' }],
  ['264', { flag: '🇳🇦', name: '纳米比亚', englishName: 'Namibia (Namibië)' }],
  ['687', { flag: '🇳🇨', name: '新喀里多尼亚', englishName: 'New Caledonia (Nouvelle-Calédonie)' }],
  ['227', { flag: '🇳🇪', name: '尼日尔', englishName: 'Niger (Nijar)' }],
  ['672', { flag: '🇳🇫', name: '诺福克岛', englishName: 'Norfolk Island' }],
  ['234', { flag: '🇳🇬', name: '尼日利亚', englishName: 'Nigeria' }],
  ['505', { flag: '🇳🇮', name: '尼加拉瓜', englishName: 'Nicaragua' }],
  ['31', { flag: '🇳🇱', name: '荷兰', englishName: 'Netherlands (Nederland)' }],
  ['47', { flag: '🇳🇴', name: '挪威', englishName: 'Norway (Norge)' }],
  ['977', { flag: '🇳🇵', name: '尼泊尔', englishName: 'Nepal (नेपाल)' }],
  ['674', { flag: '🇳🇷', name: '瑙鲁', englishName: 'Nauru' }],
  ['683', { flag: '🇳🇺', name: '纽埃', englishName: 'Niue' }],
  ['64', { flag: '🇳🇿', name: '新西兰', englishName: 'New Zealand' }],
  ['968', { flag: '🇴🇲', name: '阿曼', englishName: 'Oman' }],
  ['507', { flag: '🇵🇦', name: '巴拿马', englishName: 'Panama (Panamá)' }],
  ['51', { flag: '🇵🇪', name: '秘鲁', englishName: 'Peru (Perú)' }],
  ['689', { flag: '🇵🇫', name: '法属波利尼西亚', englishName: 'French Polynesia (Polynésie française)' }],
  ['675', { flag: '🇵🇬', name: '巴布亚新几内亚', englishName: 'Papua New Guinea' }],
  ['63', { flag: '🇵🇭', name: '菲律宾', englishName: 'Philippines' }],
  ['92', { flag: '🇵🇰', name: '巴基斯坦', englishName: 'Pakistan' }],
  ['48', { flag: '🇵🇱', name: '波兰', englishName: 'Poland (Polska)' }],
  [
    '508',
    { flag: '🇵🇲', name: '圣皮埃尔和密克隆', englishName: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)' },
  ],
  ['64', { flag: '🇵🇳', name: '皮特凯恩群岛', englishName: 'Pitcairn Islands' }],
  ['1787', { flag: '🇵🇷', name: '波多黎各', englishName: 'Puerto Rico' }],
  ['970', { flag: '🇵🇸', name: '巴勒斯坦', englishName: 'Palestine' }],
  ['351', { flag: '🇵🇹', name: '葡萄牙', englishName: 'Portugal' }],
  ['680', { flag: '🇵🇼', name: '帕劳', englishName: 'Palau' }],
  ['595', { flag: '🇵🇾', name: '巴拉圭', englishName: 'Paraguay' }],
  ['974', { flag: '🇶🇦', name: '卡塔尔', englishName: 'Qatar' }],
  ['262', { flag: '🇷🇪', name: '留尼汪', englishName: 'Réunion (La Réunion)' }],
  ['40', { flag: '🇷🇴', name: '罗马尼亚', englishName: 'Romania (România)' }],
  ['381', { flag: '🇷🇸', name: '塞尔维亚', englishName: 'Serbia (Србија)' }],
  ['7', { flag: '🇷🇺', name: '俄罗斯', englishName: 'Russia (Россия)' }],
  ['250', { flag: '🇷🇼', name: '卢旺达', englishName: 'Rwanda' }],
  ['966', { flag: '🇸🇦', name: '沙特阿拉伯', englishName: 'Saudi Arabia' }],
  ['677', { flag: '🇸🇧', name: '所罗门群岛', englishName: 'Solomon Islands' }],
  ['248', { flag: '🇸🇨', name: '塞舌尔', englishName: 'Seychelles' }],
  ['46', { flag: '🇸🇪', name: '瑞典', englishName: 'Sweden (Sverige)' }],
  ['65', { flag: '🇸🇬', name: '新加坡', englishName: 'Singapore' }],
  ['290', { flag: '🇸🇭', name: '圣赫勒拿', englishName: 'Saint Helena' }],
  ['386', { flag: '🇸🇮', name: '斯洛文尼亚', englishName: 'Slovenia (Slovenija)' }],
  ['47', { flag: '🇸🇯', name: '斯瓦尔巴群岛和扬马延岛', englishName: 'Svalbard and Jan Mayen' }],
  ['421', { flag: '🇸🇰', name: '斯洛伐克', englishName: 'Slovakia (Slovensko)' }],
  ['232', { flag: '🇸🇱', name: '塞拉利昂', englishName: 'Sierra Leone' }],
  ['378', { flag: '🇸🇲', name: '圣马力诺', englishName: 'San Marino' }],
  ['221', { flag: '🇸🇳', name: '塞内加尔', englishName: 'Senegal (Sénégal)' }],
  ['252', { flag: '🇸🇴', name: '索马里', englishName: 'Somalia (Soomaaliya)' }],
  ['597', { flag: '🇸🇷', name: '苏里南', englishName: 'Suriname' }],
  ['211', { flag: '🇸🇸', name: '南苏丹', englishName: 'South Sudan' }],
  ['239', { flag: '🇸🇹', name: '圣多美和普林西比', englishName: 'São Tomé and Príncipe (São Tomé e Príncipe)' }],
  ['503', { flag: '🇸🇻', name: '萨尔瓦多', englishName: 'El Salvador' }],
  ['1721', { flag: '🇸🇽', name: '荷属圣马丁', englishName: 'Sint Maarten' }],
  ['268', { flag: '🇸🇿', name: '斯威士兰', englishName: 'Swaziland' }],
  ['1649', { flag: '🇹🇨', name: '特克斯和凯科斯群岛', englishName: 'Turks and Caicos Islands' }],
  ['235', { flag: '🇹🇩', name: '乍得', englishName: 'Chad (Tchad)' }],
  ['228', { flag: '🇹🇬', name: '多哥', englishName: 'Togo' }],
  ['66', { flag: '🇹🇭', name: '泰国', englishName: 'Thailand (ไทย)' }],
  ['992', { flag: '🇹🇯', name: '塔吉克斯坦', englishName: 'Tajikistan' }],
  ['690', { flag: '🇹🇰', name: '托克劳', englishName: 'Tokelau' }],
  ['993', { flag: '🇹🇲', name: '土库曼斯坦', englishName: 'Turkmenistan' }],
  ['216', { flag: '🇹🇳', name: '突尼斯', englishName: 'Tunisia' }],
  ['676', { flag: '🇹🇴', name: '汤加', englishName: 'Tonga' }],
  ['90', { flag: '🇹🇷', name: '土耳其', englishName: 'Turkey (Türkiye)' }],
  ['1868', { flag: '🇹🇹', name: '特立尼达和多巴哥', englishName: 'Trinidad and Tobago' }],
  ['688', { flag: '🇹🇻', name: '图瓦卢', englishName: 'Tuvalu' }],
  ['886', { flag: '🇹🇼', name: '台湾', englishName: 'Taiwan (台灣)' }],
  ['255', { flag: '🇹🇿', name: '坦桑尼亚', englishName: 'Tanzania' }],
  ['380', { flag: '🇺🇦', name: '乌克兰', englishName: 'Ukraine (Україна)' }],
  ['256', { flag: '🇺🇬', name: '乌干达', englishName: 'Uganda' }],
  // ['1_1', { flag: '🇺🇸', name: '美国', englishName: 'United States' }],
  ['598', { flag: '🇺🇾', name: '乌拉圭', englishName: 'Uruguay' }],
  ['998', { flag: '🇺🇿', name: '乌兹别克斯坦', englishName: 'Uzbekistan (Oʻzbekiston)' }],
  ['379', { flag: '🇻🇦', name: '梵蒂冈', englishName: 'Vatican City (Città del Vaticano)' }],
  ['1784', { flag: '🇻🇨', name: '圣文森特和格林纳丁斯', englishName: 'Saint Vincent and the Grenadines' }],
  ['58', { flag: '🇻🇪', name: '委内瑞拉', englishName: 'Venezuela' }],
  ['1284', { flag: '🇻🇬', name: '英属维尔京群岛', englishName: 'British Virgin Islands' }],
  ['1340', { flag: '🇻🇮', name: '美属维尔京群岛', englishName: 'U.S. Virgin Islands' }],
  ['84', { flag: '🇻🇳', name: '越南', englishName: 'Vietnam (Việt Nam)' }],
  ['678', { flag: '🇻🇺', name: '瓦努阿图', englishName: 'Vanuatu' }],
  ['681', { flag: '🇼🇫', name: '瓦利斯和富图纳', englishName: 'Wallis and Futuna (Wallis-et-Futuna)' }],
  ['685', { flag: '🇼🇸', name: '萨摩亚', englishName: 'Samoa' }],
  ['383', { flag: '🇽🇰', name: '科索沃', englishName: 'Kosovo' }],
  ['967', { flag: '🇾🇪', name: '也门', englishName: 'Yemen' }],
  ['262', { flag: '🇾🇹', name: '马约特', englishName: 'Mayotte' }],
  ['27', { flag: '🇿🇦', name: '南非', englishName: 'South Africa' }],
  ['260', { flag: '🇿🇲', name: '赞比亚', englishName: 'Zambia' }],
];

export const EMOJI_FLAG_MAP = new Map(CodeDataMap.map((data) => [data[0], data[1]?.flag]));

export const phoneCNReg = new RegExp(/^1[0-9][0-9]\d{8}$/);
// export const mailReg = new RegExp(
//   /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
// )
export const mailReg =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const USAStateList = [
  { value: 'AK', text: 'Alaska' },
  { value: 'AL', text: 'Alabama' },
  { value: 'AR', text: 'Arkansas' },
  { value: 'AS', text: 'American Samoa' },
  { value: 'AZ', text: 'Arizona' },
  { value: 'CA', text: 'California' },
  { value: 'CO', text: 'Colorado' },
  { value: 'CT', text: 'Connecticut' },
  { value: 'DC', text: 'District of Columbia' },
  { value: 'DE', text: 'Delaware' },
  { value: 'FL', text: 'Florida' },
  { value: 'GA', text: 'Georgia' },
  { value: 'GU', text: 'Guam' },
  { value: 'HI', text: 'Hawaii' },
  { value: 'IA', text: 'Iowa' },
  { value: 'ID', text: 'Idaho' },
  { value: 'IL', text: 'Illinois' },
  { value: 'IN', text: 'Indiana' },
  { value: 'KS', text: 'Kansas' },
  { value: 'KY', text: 'Kentucky' },
  { value: 'LA', text: 'Louisiana' },
  { value: 'MA', text: 'Massachusetts' },
  { value: 'MD', text: 'Maryland' },
  { value: 'ME', text: 'Maine' },
  { value: 'MI', text: 'Michigan' },
  { value: 'MN', text: 'Minnesota' },
  { value: 'MO', text: 'Missouri' },
  { value: 'MS', text: 'Mississippi' },
  { value: 'MT', text: 'Montana' },
  { value: 'NC', text: 'North Carolina' },
  { value: 'ND', text: 'North Dakota' },
  { value: 'NE', text: 'Nebraska' },
  { value: 'NH', text: 'New Hampshire' },
  { value: 'NJ', text: 'New Jersey' },
  { value: 'NM', text: 'New Mexico' },
  { value: 'NV', text: 'Nevada' },
  { value: 'NY', text: 'New York' },
  { value: 'OH', text: 'Ohio' },
  { value: 'OK', text: 'Oklahoma' },
  { value: 'OR', text: 'Oregon' },
  { value: 'PA', text: 'Pennsylvania' },
  { value: 'PR', text: 'Puerto Rico' },
  { value: 'RI', text: 'Rhode Island' },
  { value: 'SC', text: 'South Carolina' },
  { value: 'SD', text: 'South Dakota' },
  { value: 'TN', text: 'Tennessee' },
  { value: 'TX', text: 'Texas' },
  { value: 'UT', text: 'Utah' },
  { value: 'VA', text: 'Virginia' },
  { value: 'VI', text: 'Virgin Islands' },
  { value: 'VT', text: 'Vermont' },
  { value: 'XK', text: 'Kosovo' },
  { value: 'WA', text: 'Washington' },
  { value: 'WI', text: 'Wisconsin' },
  { value: 'WV', text: 'West Virginia' },
  { value: 'WY', text: 'Wyoming' },
];

export const USAJobList = [
  'Not Known',
  'Aerospace/Defense',
  'Airport',
  'Arts & Entertainment',
  'Automobiles and Parts',
  'Automotive',
  'Bank & Financial Services',
  'Bank/Financial Institution',
  'Bar',
  'Biotechnology',
  'Book Store',
  'Business Services',
  'Cause',
  'Chemicals',
  'Club',
  'Community Organization',
  'Community/Government',
  'Company',
  'Computers/Technology',
  'Concert Venue',
  'Consulting/Business Services',
  'Doctor',
  'Education',
  'Elementary School',
  'Energy/Utility',
  'Engineering/Construction',
  'Event Planning/Event Services',
  'Farming/Agriculture',
  'Food/Beverages',
  'Food/Grocery',
  'Government Organization',
  'Health/Beauty',
  'Health/Medical/Pharmaceuticals',
  'Health/Medical/Pharmacy',
  'Home Improvement',
  'Hospital/Clinic',
  'Hotel',
  'Industrials',
  'Insurance Company',
  'Internet/Software',
  'Landmark',
  'Lawyer',
  'Legal/Law',
  'Library',
  'Licensed Financial Representative',
  'Local Business',
  'Media/News/Publishing',
  'Middle School',
  'Mining/Materials',
  'Movie Theater',
  'Museum/Art Gallery',
  'Non-Governmental Organization (NGO)',
  'Non-Profit Organization',
  'Organization',
  'Outdoor Gear/Sporting Goods',
  'Pet Services',
  'Political Organization',
  'Political Party',
  'Preschool',
  'Professional Services',
  'Public Places',
  'Real Estate',
  'Religious Organization',
  'Restaurant/Cafe',
  'Retail and Consumer Merchandise',
  'School',
  'Shopping/Retail',
  'Small Business',
  'Spas/Beauty/Personal Care',
  'Sports Venue',
  'Sports/Recreation/Activities',
  'Telecommunication',
  'Tours/Sightseeing',
  'Train Station',
  'Transport/Freight',
  'Transportation',
  'Travel/Leisure',
  'University',
];
// 语言配置
export const LANGUAGE_CONFIG = [
  {
    id: 'english',
    path: 'en',
    flag: english_flag,
    label: 'English',
  },
  {
    id: 'china',
    path: 'cn',
    flag: china_flag,
    label: '简体中文',
  },
  {
    id: 'tw',
    path: 'zh-TW',
    flag: china_flag,
    label: '繁體中文',
  },
  {
    id: 'japan',
    path: 'jp',
    flag: japan_flag,
    label: '日本語',
  },
  // 暂时去除韩语
  // {
  //   id: 'korean',
  //   path: 'kr',
  //   flag: require('../../assets/img/korean_flag.png'),
  //   label: '한국어',
  // },
  {
    id: 'vietnam',
    path: 'vn',
    flag: vietnam_flag,
    label: 'Tiếng Việt',
  },
  {
    id: 'russia',
    path: 'ru',
    flag: russia_flag,
    label: 'Русский',
  },
  {
    id: 'turkey',
    path: 'tr',
    flag: turkey_flag,
    label: 'Türkiye',
  },
  {
    id: 'spanish',
    path: 'es',
    flag: spanish_flag,
    label: 'Español',
  },
  {
    id: 'brazil',
    path: 'br',
    flag: brazil_flag,
    label: 'Português',
  },
];

export const OPERATION_BIZ_TYPE = {
  // 手机绑定
  PHONE_BIND: 'PHONE_BIND',
  // 手机换绑
  PHONE_REPLACE: 'PHONE_REPLACE',
  // 邮箱绑定
  EMAIL_BIND: 'EMAIL_BIND',
  // 邮箱换绑
  EMAIL_REPLACE: 'EMAIL_REPLACE',
  // 谷歌绑定
  GOOGLE_BIND: 'GOOGLE_BIND',
  // 谷歌换绑
  GOOGLE_REPLACE: 'GOOGLE_REPLACE',
  // 修改密码 mfa-v2
  PASSWORD_MODIFY: 'PASSWORD_MODIFY',
  // 找回密码 mfa-v3
  PASSWORD_FORGET: 'PASSWORD_FORGET',
  // 添加美元银行账户验证规则	mfa-v2
  '/asset/bank/login': '/asset/bank/login',
  // 美元ACH充值验证规则	mfa-v2
  '/asset/fiat/bank/deposit': '/asset/fiat/bank/deposit',
  // 美元ACH提现验证规则	mfa-v2 & 美元Wire提现验证规则 mfa-v2
  '/asset/fiat/withdraw': '/asset/fiat/withdraw',
  // API 管理
  '/user-center/user-api': '/user-center/user-api',
  '/user-center/user-api-create': '/user-center/user-api-create',
  '/user-center/user-api-update': '/user-center/user-api-update',
  '/gateway-auth/user-api': '/gateway-auth/user-api',
  '/gateway-auth/user-api-create': '/gateway-auth/user-api-create',
  '/gateway-auth/user-api-update': '/gateway-auth/user-api-update',
  // 新建和修改提币地址
  '/create/coinWithdrawlAddr': '/asset/account/create/coinWithdrawlAddr',
  // 虚拟币提现
  '/virtualCoin/withdraw-v2': '/asset/account/virtualCoin/withdrawl-v2',
  '/asset/virtual/withdraw': '/asset/virtual/withdraw',
  // 内部提现
  '/virtualCoin/internal-withdraw': '/asset/virtual/initInternalWithdraw',
  // 用户新增或修改防钓鱼码
  '/anti-fishing-code/update': '/user-center/anti-fishing-code/update',

  // nft提现
  '/nft-market/withdraw/doWithdraw': '/nft-market/withdraw/doWithdraw',

  // TODO:51 p2p
  '/p2p/addPaymentMethod':'',
  // 以下是登陆相关
  LOGIN: 'LOGIN',
  AUTH_DEVICE: 'AUTH_DEVICE',
};

/**
 * 交易类型枚举
 */
export const TRADE_ORDER_TYPE_ENUM = {
  // 限价单
  LIMIT: 'LIMIT',
  // 市价单
  MARKET: 'MARKET',
  LIMIT_MAKER: 'LIMIT_MAKER',
  IOC: 'IOC',
  // 计划委托
  TRIGGER_ORDER: 'TRIGGER_ORDER',
  // 止盈止损
  STOP_LIMIT: 'STOP_LIMIT',
  // 高级限价委托
  ADVANCED_LIMIT: 'ADVANCED_LIMIT',
};

/**
 * 交易类型
 */
export const TRADE_ORDER_TYPE = {
  // 限价单
  LIMIT: 0,
  // 市价单
  MARKET: 1,
  LIMIT_MAKER: 2,
  IOC: 3,
};

export const TRADE_ENTRUST_TYPE = {
  // 0-全部
  ALL: 0,
  // 1-未成交
  UNCOMPLETED: 1,
  // 2-部分成交
  PARTIAL_COMPLETED: 2,
  // 3-完全成交
  COMPLETED: 3,
  // 4-用户撤销
  CANCELED: 4,
  // 5-当前委托
  CURRENT: 5,
  // 6-历史委托
  HISTORY: 6,
};

/**
 * 委托单状态 老的状态，也在用，detail之类的
 */
export const ENTRUST_STATE = {
  /**
   * 下单失败
   */
  FAIL: 1,
  /**
   * 下单成功
   */
  SUCCESS: 2,
  /**
   * 冻结失败
   */
  FREEZE_FAIL: 3,
  /**
   * 冻结成功
   */
  FREEZE_SUCCESS: 4,
  /**
   * 部分成交
   */
  PARTIAL_COMPLETE: 5,
  /**
   * 完全成交
   */
  COMPLETE: 6,
  /**
   * 撤销中
   */
  CANCELLING: 7,
  /**
   * 撤销成功
   */
  CANCELLED: 8,
  /**
   * 部分成交后撤销
   */
  PARTIAL_COMPLETE_AND_CANCELLED: 11,
  /**
   * 触发-成功触发
   */
  TRIGGER_TRIGGERED: 6,
  /**
   * 触发-触发撤销
   */
  TRIGGER_CANCELLED: 8,
};

/**
 * 新委托单状态
 */
export const ENTRUST_STATE_NEW = {
  /**
   * 下单成功
   */
  SUCCESS: 'new',
  /**
   * 部分成交
   */
  PARTIAL_COMPLETE: 'partially_filled',
  /**
   * 完全成交
   */
  COMPLETE: 'filled',

  /**
   * 撤销成功
   */
  CANCELLED: 'canceled',
  /**
   * 部分成交后撤销
   */
  PARTIAL_COMPLETE_AND_CANCELLED: 'partially_canceled',
};

/**
 * WS 推送消息类型
 */
export const WS_EVNET_TYPE = {
  TRADE_SUCCESS: 'trade_success',
  NEW_ENTRUST: 'new_entrust',
  CANCEL_ENTRUST: 'cancel_entrust',
};

// 法币符号
// www.xe.com/zh-CN/currencyconverter/convert/?Amount=1&From=KWD&To=USD
export const fiatJSON = {
  USD: '$',
  ARS: 'ARS$',
  AED: 'د.إ',
  AUD: 'A$',
  AZN: '₼',
  BRL: 'R$',
  BGN: 'лв',
  BOB: '$b',
  BDT: '৳',
  CHF: 'CHF',
  CLP: '$',
  CRC: '₡',
  CNY: '¥',
  COP: 'COL$',
  CAD: 'C$',
  CZK: 'Kč',
  DKK: 'KR',
  DOP: 'RD$',
  EUR: '€',
  EGP: '£',
  GBP: '£',
  GEL: '₾',
  HUF: 'Ft',
  HRK: 'kn',
  HKD: 'HKD',
  INR: '₹',
  ILS: '₪',
  IDR: 'Rp',
  JPY: '¥',
  JOD: 'JD',
  KES: 'KSh',
  KRW: '₩',
  KWD: 'KD',
  KZT: '₸',
  LKR: '₨',
  MYR: 'RM',
  MAD: 'م.د.',
  MDL: 'lei',
  MXN: 'Mex$',
  NOK: 'kr',
  NAD: '$',
  NGN: '₦',
  NZD: 'NZ$',
  OMR: '﷼',
  PEN: 'S/.',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  QAR: '﷼',
  RUB: '₽',
  RON: 'lei',
  SAR: 'ر.س',
  SGD: 'S$',
  SEK: 'kr',
  TWD: 'NT$',
  THB: '฿',
  TRY: '₺',
  UAH: '₴',
  UYU: '$U',
  UZS: 'лв',
  UGX: 'USh',
  VND: '₫',
  VES: 'Bs',
  ZAR: 'R',
} as {[x: string]: string};

// 赠金活动任务状态
export const GIVEAWAY_TASK_TYPE = [
  'REGISTER_TASK', // 开通合约任务
  'TRANSFER_IN_TASK', // 首充任务
  'TRADE_VALUE_1_TASK', //交易额度1 任务
  'DAILY_TRADE_TASK', // 每日交易 任务
  'TRADE_VALUE_2_TASK', // 交易额度2 任务
  'TRADE_VALUE_3_TASK', // 交易额度3 任务
];
// 赠金活动用户页面状态「这里的状态由前端维护，非接口返回的状态」
export const GIVEAWAY_STATUS_TYPE = {
  NOT_LOGIN: -1, // 未登录
  NOT_ENROLL: 0, // 未报名
  ENROLLED: 1, // 已报名
};
// 赠金活动任务状态
export const GIVEAWAY_TASK_STATUS = {
  UNDEFINED: 0, // 未初始化
  NOT_FINISH: 1, // 未完成
  WAIT_REC: 2, // 已完成未领取
  IS_REC: 3, // 已领取
  OLD_USER: 4, // 老用户
};

export const INVITE_CODE_MAP = {};

// 交易页 委托历史tab项
export const ORDER_TRADE_TAB_ENUM = {
  OPEN_ORDERS: 'OPEN_ORDERS', // 当前委托
  ORDER_HISTORY: 'ORDER_HISTORY', // 历史委托
  ASSETS_FUNDS: 'ASSETS_FUNDS', // 资产管理
  ASSETS_POSITIONS: 'ASSETS_POSITIONS', // 仓位
};

export const ORDER_TRADE_TYPE_ENUM = {
  SPOT_MARKET: 'SPOT_MARKET',
  SPOT_TRIGGER: 'SPOT_TRIGGER',
  SPOT_STOP: 'SPOT_STOP',
  MARGIN: 'MARGIN',
};

// 取消订单还在用
export const ORDER_TRADE_PLAN_TYPE_ENUM_OLD = {
  SPOT_MARKET: 0,
  SPOT_TRIGGER: 2,
  SPOT_STOP: 1,
};

export const ORDER_TRADE_PLAN_TYPE_ENUM = {
  SPOT_MARKET: 'spot_margin',
  SPOT_TRIGGER: 'trigger_order',
  SPOT_STOP: 'stop_limit',
};

export const settlementTypes = [
  'first_trading_bonus',
  'margin_first_exchange',
  'open_margin_account',
  'earn_first_exchange',
  'nft_first_exchange',
  'contract_total_exchange',
  'open_contract_account',
  'staking',
  'reward',
  'lending',
  'airdrop',
  'giftbox',
  'deflationary_reward',
  'market_reward',
  'trade_race',
  'fee_return',
  'nft',
  'invite_and_exchange',
  'spot_total_exchange',
  'earn_total_exchange',
  'fiat_total_recharge',
  'registration_bonus',
  'first_deposit_bonus',
  // 新加的
  'Rewards',
  'Airdrop',
  'Market Commission',
  'Trading Competition Rewards',
  'Vote Listing Airdrop',
  'Salary and Bonus',
  'Listing Fee Commission',
  'Activity Commission',
  'Trading Fee Voucher',
  'Deflationary Token Rewards',
  'Rewards Hub Bonus',
  'rewards',
  'spot_symbol_total_exchange',
  'qualification',
];

export const KYC_BIZ_TYPE_MAP = {
  /// 数字币充值
  digitalrRecharge: 0,
  /// 买币(H5)
  digitalrBuy: 1,
  /// 数字币提现
  digitalrWithdrawal: 2,
  /// 内部提现
  digitalrInternalWithdrawal: 3,
  /// 卖币(H5)
  digitalrSell: 4,
  /// 现货交易
  spotTrading: 5,
  /// 合约交易
  contractTrading: 6,
  /// 理财
  earnTrading: 7,
  /// 现货杠杆
  spotMargin: 8,
  /// nft
  nft: 9,
};

// 48239  创建订单 kyc >2 非白名单用户
// 48114   创建委托单 kyc >2 非白名单用户
export const KYC_ERROR_CODE = {
  33135: 1,
  33136: 2,
  33140: 'limitCountry',
  33137: 'limitCountry',
  32086: 1,
  32087: 2,
  32088: 'limitCountry',
  48014: 1,
  48015: 2,
  48016: 'limitCountry',
  34015: 2, // 理财kyc2错误码
  34063: 1, // 理财kyc1错误码
  34064: 2, // 理财kyc2错误码
  34065: 'limitCountry', // 理财 国家限制 错误码
  55000: 1,
  55001: 2,
  55002: 'limitCountry', // 卡交易 国家限制 错误码
};

export const PRO_TRADE_MODE_ENUM = {
  SPOT: 'SPOT',
  MARGIN: 'MARGIN',
};

// 可以和上面的合并
export const BASIC_TRADE_MODE_ENUM = {
  SPOT: 'SPOT',
  MARGIN: 'MARGIN',
};

export const TRADE_PAGE_LAYOUT = {
  BASIC: 'BASIC',
  PRO: 'PRO',
};

export const AREA_CODE_COUNTRY_MAP = new Map(CodeDataMap);

export const PwdValidateEnum = {
  AtLess8Char: 0, // 至少八位字符
  AtLess1UppercaseLetter: 1, // 最少一个大写字母
  AtLess1LowercaseLetter: 2, // 最少一个小写字母
  AtLess1Numer: 3, // 最少一个数字
  AtLess1Symbol: 4, // 最少一个字符
};

export const SENTRY_ENABLE =
  process.env.NODE_ENV === 'production' && ['testing', 'production'].includes(domain_env);

// 国家列表/手机区号的业务类型
export const COUNTRY_BIZ_TYPE_ENUM = {
  ALL: 0, // 所有国家，包括我们自定义的国家
  KYC: 1, // 支持kyc的国家
  REGISTER: 2, // 注册、绑定、换绑、机构申请等支持的国家
  ALL_AREA_CODE: 3, // 有区号的所有国家，不包括自定义国家，目前用于登陆/找回密码
};
